import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { AuctionResponseDto } from '../schemas/auction-response.dto';
import { AUCTION_FLOW_API_BASE_URL } from '../api-base-url.token';

@Injectable({ providedIn: 'root' })
export class AuctionApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(AUCTION_FLOW_API_BASE_URL)}/Auction`;

    getAll(tradingProcedureId: number) {
        return this.builder
            .url(`${this.controllerUrl}/getAll`)
            .get()
            .json<AuctionResponseDto[]>()
            .withHttpParams(new HttpParams().set('tradingProcedureId', String(tradingProcedureId)))
            .build()
            .send();
    }

    getById(auctionId: number) {
        return this.builder
            .url(`${this.controllerUrl}/getById`)
            .get()
            .json<AuctionResponseDto>()
            .withHttpParams(new HttpParams().set('auctionId', String(auctionId)))
            .build()
            .send();
    }
}
